import type { IOverlayLayoutProps } from './OverlayLayout'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/index'

export const OverlayLayoutStyled = styled.div<IOverlayLayoutProps>`
  display: ${({ overlayEnabled }) => (overlayEnabled ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: ${({ overlayFullColor }) =>
    `var(${overlayFullColor || COLOR.TRANSPARENT})`};

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
  }

  &:before {
    display: ${({ overlayWidth, overlayHorizontalColor }) =>
      overlayWidth && overlayHorizontalColor ? 'block' : 'none'};
    width: ${({ overlayWidth }) => overlayWidth || 0};
    height: 100%;
    background: ${({ overlayHorizontalColor }) =>
      `var(${overlayHorizontalColor})`};
  }

  &:after {
    display: ${({ overlayHeight, overlayVerticalColor }) =>
      overlayHeight && overlayVerticalColor ? 'block' : 'none'};
    width: 100%;
    height: ${({ overlayHeight }) => overlayHeight || 0};
    background: ${({ overlayVerticalColor }) => `var(${overlayVerticalColor})`};
  }
`
